import React from "react";
import PropTypes from 'prop-types';

export default function ChatSuggestion({ text, onClick }) {
  return (
    <div
      className="d-flex align-items-center chat-suggestions-block"
      onClick={onClick}
    >
      {text}
    </div>
  );
}

export const auditTrailSuggestions = [
  {
    text: "Summarize Audit Trail",
    prompt: `Can you provide a concise summary of the following text? 
    The summary should cover all the key points and main ideas presented in the original text, 
    while also condensing the information into a concise and easy-to-understand format. 
    Please ensure that the summary includes relevant details and examples that support the main ideas, 
    while avoiding any unnecessary information or repetition. The length of the summary should be appropriate for the length 
    and complexity of the original text, providing a clear and accurate overview without omitting any important information`,
    message: "Provide a concise summary of the audit trail.",
  },
  {
    text: "Identify key actionable items",
    prompt:
      "Identify key actionable items and make it concise from the following content:",
    message: "Identify key actionable items",
  },
];

export const formSuggestions = [
  {
    text: "Summarize Form",
    prompt: `Can you provide a concise summary of the following text? 
    The summary should cover all the key points and main ideas presented in the original text, 
    while also condensing the information into a concise and easy-to-understand format. 
    Please ensure that the summary includes relevant details and examples that support the main ideas, 
    while avoiding any unnecessary information or repetition. The length of the summary should be appropriate for the length 
    and complexity of the original text, providing a clear and accurate overview without omitting any important information`,
    message: "Provide a concise summary of the form.",
  }
];

ChatSuggestion.propTypes = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};
